import script from "./WidgetGlobalSearchBar.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetGlobalSearchBar.vue?vue&type=script&setup=true&lang=js"

import "./WidgetGlobalSearchBar.vue?vue&type=style&index=0&id=e26504f8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e26504f8"]])

export default __exports__